import { AutogenLayoutCashedWiresTransactionReport } from "./autogen/AutogenLayoutCashedWiresTransactionReport";
import { Api } from "@mcleod/core";

export class CashedWiresTransactionReport extends AutogenLayoutCashedWiresTransactionReport {
  
    override async onLoad(): Promise<void> {
        this.textboxFuelInterfaceId.visible = false;
        const response = await Api.search("lme/dispatch/asset/fuel-interface-configured", {});
            this.textboxFuelInterfaceId.visible = response.data.length >= 2;

    }


}